import { gql, TypedDocumentNode } from '@apollo/client'

import { ERROR_FRAGMENT } from 'providers/graphql'
import { Data, Variables } from './types'

export const UPLOAD_AD_UNITS_CONFIGURATION: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation uploadAdUnitsConfiguration($input: UploadAdUnitsXlsInput!) {
    uploadAdUnitsXls(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
